import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import { Search } from 'lucide-react'
import { tokens } from '../../../assets/tokens'

// Buscador de las filas de filtros, como el de Usuarios en Velora: sin etiqueta, con la lupa
// dentro y el texto en el placeholder. La altura y el borde salen del tema (MuiOutlinedInput).
const SearchInput = ({ value, defaultValue, onChange, placeholder, width, style, inputProps, ...rest }) => (
  <TextField
    variant="outlined"
    value={value}
    defaultValue={defaultValue}
    placeholder={placeholder}
    onChange={onChange ? e => onChange(e.target.value, e) : undefined}
    style={{ width, ...style }}
    inputProps={{ autoComplete: 'off', ...inputProps }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Search size={18} color={tokens.color.text.disabled} />
        </InputAdornment>
      )
    }}
    {...rest}
  />
)

SearchInput.propTypes = {
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  inputProps: PropTypes.object
}

SearchInput.defaultProps = {
  width: 320
}

export default SearchInput
